import { memo, useMemo } from 'react'
import { Banner, Footer, Header } from '@/components/Surface'
import { useDomainInfo } from '@/utils'
import { withErrorBoundary } from '@/components/Utils'
import { PageLayoutProps } from './PageLayout.types'
import { isValidTheme } from './PageLayout.utils'

function PageLayout({
  banner = false,
  headerProps = {},
  bannerProps = {},
  footer = false,
  children,
  packageInfo,
  theme,
  hidePackageInfo,
  pageConfig,
}: PageLayoutProps) {
  const { isFanaticsDomain } = useDomainInfo()

  const validTheme = useMemo(
    () =>
      isValidTheme(theme ?? packageInfo?.pageTheme) ? (theme ?? packageInfo?.pageTheme) : undefined,
    [packageInfo?.pageTheme, theme],
  )

  const config = pageConfig ?? packageInfo?.pageConfig

  return (
    <>
      <Header
        packageInfo={packageInfo}
        theme={validTheme}
        hasBanner={banner}
        hidePackageInfo={hidePackageInfo}
        pageConfig={config}
        {...headerProps}
      />

      {validTheme && (
        <style>{`
          :root {
            --mui-palette-button-backgroundPrimary: ${validTheme.primaryColor};
            --mui-palette-button-hoverPrimary: ${validTheme.primaryColor};
            --mui-palette-pageTheme-primaryColor: ${validTheme.primaryColor};
            --mui-palette-pageTheme-secondaryColor: ${validTheme.secondaryColor};
            --mui-palette-pageTheme-textColor: ${validTheme.textColor};
            --mui-palette-pageTheme-mapHighlightColor: ${validTheme.primaryColor};
          }
        `}</style>
      )}

      <main>
        {banner && (
          <Banner
            theme={validTheme}
            isMainHeaderTransparent={headerProps.transparent ?? false}
            {...bannerProps}
          />
        )}
        {children}
      </main>

      {!isFanaticsDomain && footer && <Footer />}
    </>
  )
}

export default memo(withErrorBoundary(PageLayout))
